import React from 'react';
import './Products.css';

function Products() {
  const products = [
    {
      grade: 'W180',
      description: 'Premium whole cashew kernels with superior quality and rich flavor.'
    },
    {
      grade: 'W240',
      description: 'Medium-sized kernels offering perfect balance of size and taste.'
    },
    {
      grade: 'W320',
      description: 'Larger kernels with exceptional taste and premium texture.'
    }
  ];

  return (
    <section className="products" id="products">
      <div className="container">
        <div className="products-header">
          <h2>Our Products</h2>
          <p>Premium cashew kernels in various grades, processed with care and expertise</p>
        </div>

        <div className="products-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              <div className="product-grade">
                <h3>{product.grade}</h3>
              </div>
              <div className="product-content">
                <p className="product-description">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;